var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vc-button',{class:['become-a-patron'],attrs:{"tag":"a","to":"https://www.patreon.com/vuecidity","target":"_blank"},on:{"click":function($event){_vm.sendGaEvent('Support', 'support button click', 'Patreon')}}},[_c('img',{attrs:{"src":"/static/images/patreon-logo.png","width":"24","height":"24"}}),_vm._v("Become a patron\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f259145","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/patreon-button/PatreonButton.vue
// module id = null
// module chunks = 